import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dd099acc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=dd099acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd099acc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd099acc')) {
      api.createRecord('dd099acc', component.options)
    } else {
      api.reload('dd099acc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dd099acc&scoped=true&", function () {
      api.rerender('dd099acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DtFormItem/index.vue"
export default component.exports